export const isOptedIn = (feature: string): boolean => {
  return !ADV.data.user.OptOuts.includes(feature);
};
